export default __webpack_public_path__ + "static/chev-2a0a3119b9e88edec6eeaa0ab58a7959.png";